<template>
  <div class="modal-out">
    <div class="modal">

      <div class="modal-header">
        <div class="title">活动参与人</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="padding: 10px;">

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="普通老人" name="first">
            <Part1 ref="myPart1"></Part1>
          </el-tab-pane>
          <el-tab-pane label="工作人员" name="second">
            <Part2 ref="myPart2"></Part2>
          </el-tab-pane>
        </el-tabs>

      </div>

    </div>


  </div>
</template>

<script>

import Part1 from "./Part1";
import Part2 from "./Part2";

export default {
  name: 'ElderlyInsCheckIn',
  data() {
    return {

      loading: false,

      activityOrderCode:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      th:this.$store.state.tableHeight,

      row:null,
      activeName: '',

    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th=val
    },
  },
  components:{
    Part1,Part2
  },
  methods: {
    init(row){
      this.activityOrderCode = row.activityOrderCode;
      this.row = row;

      this.activeName = 'first';
      this.$refs.myPart1.init(this.row);

    },
    closeSelf() {
      this.$emit("closePeople");
    },

    handleClick(tab, event) {
      //console.log(tab, event);
      //console.log(tab.name);

      if(tab.name == 'first'){
        this.$refs.myPart1.init(this.row);
      }
      if(tab.name == 'second'){
        this.$refs.myPart2.init(this.row);
      }

    },


  }
}


</script>

<style lang="scss" scoped>

</style>
